"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SitecoreContextEvents = (function () {
    function SitecoreContextEvents() {
    }
    return SitecoreContextEvents;
}());
SitecoreContextEvents.onSitecoreContextInitialization = "onSitecoreContextInitialization";
exports.SitecoreContextEvents = SitecoreContextEvents;



//////////////////
// WEBPACK FOOTER
// ./src/events/ContextEvents.ts
// module id = 1
// module chunks = 13 14